export const ScheduleEditor = {
  attributes: {
    scheduleDropdown: "schedule-dropdown"
  }
};
